const { String } = require('../../String/String')
const { is } = require('../../is/is')

/**
 * Visszaadja a megadott dátumból az év-hónap-napot.
 * Alapértelmezetten, paraméter nélkül a mai nap dátumát adja vissza.
 * @example
 * 2016-01-01 // YYYY-mm-dd
 * @param {string | number | Date} tmp - Az opcionális paraméter, amiből a dátum rész kell.
 * @returns {string} Az ISO dátum.
 */
module.exports.getDate = function getDate (tmp = Date.now()) {
  const date = is.instanceOf(tmp, Date) ? tmp : new Date(tmp)

  const utcDate = `${ date.getFullYear() }-${ String.pad(date.getMonth() + 1) }-${ String.pad(date.getDate()) }`

  return utcDate
}
